var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.473,
    height: 15.415,
    viewBox: "0 0 15.473 15.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pdf",
    d: "M18.356,12.755c-.387-.62-1.317-.852-2.866-.852a11.44,11.44,0,0,0-1.627.077c-.387-.232-.775-.465-1.084-.7a7.746,7.746,0,0,1-2.014-3.176.24.24,0,0,1,.077-.155c.387-1.627.775-3.641,0-4.493a1,1,0,0,0-.775-.31h-.31c-.465,0-.852.465-1.007.93a5.97,5.97,0,0,0,.31,4.028,17.062,17.062,0,0,1-1.394,3.718c-.387.852-.852,1.627-1.162,2.246a10.609,10.609,0,0,0-1.084.62A4.772,4.772,0,0,0,3.1,17.326a.849.849,0,0,0,0,.62v.077l.62.387a1.436,1.436,0,0,0,.542.155c1.007,0,2.169-1.162,3.718-3.873.077,0,.155-.077.232-.077a28.119,28.119,0,0,1,5.035-.93,9.336,9.336,0,0,0,3.718.93,1.6,1.6,0,0,0,1.162-.387,1.719,1.719,0,0,0,.387-.852.835.835,0,0,0-.155-.62M4.1,17.713a4.4,4.4,0,0,1,1.549-2.092c.155-.077.31-.232.62-.387A6.5,6.5,0,0,1,4.1,17.713M9.835,4c.077-.077.077-.155.155-.155l.155.077c.232.31.232.7.077,1.394v.232A6.115,6.115,0,0,1,9.99,6.558,5.029,5.029,0,0,1,9.835,4m-1.549,9.76-.155.077a6.575,6.575,0,0,1,.62-1.317A15.585,15.585,0,0,0,9.99,9.5a8.12,8.12,0,0,0,1.937,2.711,1.389,1.389,0,0,0,.542.387,20.554,20.554,0,0,0-4.183,1.162m9.373-.077h-.31a7.272,7.272,0,0,1-2.4-.62.309.309,0,0,1,.31-.155c1.782,0,2.246.31,2.4.465.077.077.077.077.077.155s0,.077-.077.155Z",
    transform: "translate(-3.038 -3.15)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ff42368b137e195dac9f7db9198d6ca9.svg";
export { ForwardRef as ReactComponent };